import "esbuild-css-modules-plugin-ns-css:src/js/components/copyLink/copyLink.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/copyLink/copyLink.module.css:injector.js";
export default new Proxy({
  "buttonStyleOverride": "copyLink-module__buttonStyleOverride_HRDyFG__1100",
  "copyLinkIcon": "copyLink-module__copyLinkIcon_HRDyFG__1100",
  "displayContainer": "copyLink-module__displayContainer_HRDyFG__1100",
  "displayLinkText": "copyLink-module__displayLinkText_HRDyFG__1100",
  "textContainer": "copyLink-module__textContainer_HRDyFG__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      